export const SOFTLINE_API_WWS_KREDITLIMIT = '/v1/wws/kreditlimit/{{idktostamm}}';
